import { API_URL } from '../constants';
export const getMenus = async (token: string, brandId: string): Promise<any> => {
  return fetch(`${API_URL}/menus`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'brand-id': brandId,
    },
  });
};
